export const mapRoleAllocationBoardToDashboard = (board) => {
  if (!board) {
    return {
      summary: {
        totalRoles: 0,
        rolesWithPeople: 0,
        rolesWithoutPeople: 0,
        rolesWithSops: 0,
        rolesWithoutSops: 0,
        fullyCoveredRoles: 0,
        uncoveredRoles: 0,
      },
      departmentRows: [],
      rolesWithoutPeople: [],
      rolesWithoutSops: [],
      rolesWithoutAnything: [],
    };
  }

  const departments = board.departments || [];
  const roleColumns = board.roles || [];

  const departmentMap = new Map(
    departments.map((department) => [department.id, department])
  );

  const totalRoles = roleColumns.length;

  const rolesWithPeople = roleColumns.filter((item) => (item.peopleCount || 0) > 0);
  const rolesWithoutPeople = roleColumns.filter((item) => (item.peopleCount || 0) === 0);
  const rolesWithSops = roleColumns.filter((item) => (item.sopCount || 0) > 0);
  const rolesWithoutSops = roleColumns.filter((item) => (item.sopCount || 0) === 0);

  const fullyCoveredRoles = roleColumns.filter(
    (item) => (item.peopleCount || 0) > 0 && (item.sopCount || 0) > 0
  );

  const rolesWithoutAnything = roleColumns.filter(
    (item) => (item.peopleCount || 0) === 0 && (item.sopCount || 0) === 0
  );

  const summary = {
    totalRoles,
    rolesWithPeople: rolesWithPeople.length,
    rolesWithoutPeople: rolesWithoutPeople.length,
    rolesWithSops: rolesWithSops.length,
    rolesWithoutSops: rolesWithoutSops.length,
    fullyCoveredRoles: fullyCoveredRoles.length,
    uncoveredRoles: rolesWithoutAnything.length,
  };

  const departmentRows = departments.map((department) => {
    const departmentRoles = roleColumns.filter(
      (item) => item.role?.departmentId === department.id
    );

    const totalDepartmentRoles = departmentRoles.length;
    const withPeople = departmentRoles.filter((item) => (item.peopleCount || 0) > 0).length;
    const withSops = departmentRoles.filter((item) => (item.sopCount || 0) > 0).length;
    const fullyCovered = departmentRoles.filter(
      (item) => (item.peopleCount || 0) > 0 && (item.sopCount || 0) > 0
    ).length;

    return {
      id: department.id,
      departmentName: department.name || "Unnamed department",
      totalRoles: totalDepartmentRoles,
      withPeople,
      withSops,
      fullyCovered,
      gaps: totalDepartmentRoles - fullyCovered,
    };
  });

  const mapGapRoleRow = (item, status) => ({
    id: item.role?.id,
    roleName: item.role?.name || "Unnamed role",
    departmentName:
      departmentMap.get(item.role?.departmentId)?.name || "Unassigned department",
    peopleCount: item.peopleCount || 0,
    sopCount: item.sopCount || 0,
    status,
  });

  return {
    summary,
    departmentRows,
    rolesWithoutPeople: rolesWithoutPeople.map((item) =>
      mapGapRoleRow(item, "Missing people")
    ),
    rolesWithoutSops: rolesWithoutSops.map((item) =>
      mapGapRoleRow(item, "Missing SOPs")
    ),
    rolesWithoutAnything: rolesWithoutAnything.map((item) =>
      mapGapRoleRow(item, "Missing people and SOPs")
    ),
  };
};